import type { FlowAttributeReferenceType } from "@validereinc/domain";
import { FlowAdapter } from "@validereinc/domain";
import { useEffect, useState } from "react";

export const useFlowTypes = () => {
  const [flowTypes, setFlowTypes] = useState<FlowAttributeReferenceType[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFlowTypes = async () => {
    setIsLoading(true);
    const newFlowTypes = await FlowAdapter.types.getList({});

    setFlowTypes(newFlowTypes.data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchFlowTypes().catch((error) => console.error(error));
  }, []);

  return { flowTypes, isLoading };
};

export const useFlowProductTypes = () => {
  const [flowProductTypes, setFlowTypes] = useState<
    FlowAttributeReferenceType[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFlowProductTypes = async () => {
    setIsLoading(true);
    const newFlowTypes = await FlowAdapter.productTypes.getList({});

    setFlowTypes(newFlowTypes.data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchFlowProductTypes().catch((error) => console.error(error));
  }, []);

  return { flowProductTypes, isLoading };
};
